export default __webpack_public_path__ + "static/media/holyspirit.1bf8f18a.jpg";